import React, { useEffect } from 'react'
import loadNIASScript from '../../utils/load-nias-script'
const ErrorPage = () => {
  useEffect(() => {
    loadNIASScript(null, null)
  }, [])
  return (
    <div>
      <h2>Neuspješna autentifikacija!</h2>
      <div>
        <button 
          className="error-button" 
          onClick={()=>{ window.location.replace(process.env.REACT_APP_REDIRECT_PAGE)}}
          >
            Odustani
        </button> 
      </div>
      
    </div>
  )
}

export default ErrorPage